require("core-js/modules/es.regexp.flags.js");
(function webpackUniversalModuleDefinition(e, r) {
  if (typeof exports === "object" && typeof module === "object") module.exports = r(require("@mq/aurora-logging"), require("@mq/aurora-redux-middleware"), require("ldclient-js"), require("lodash-es/intersectionWith"), require("lodash-es/isEmpty"), require("lodash-es/isEqual"), require("lodash-es/isString"), require("lodash-es/memoize"), require("lodash-es/sortBy"), require("lodash-es/uniqueId"), require("react"), require("rxjs"), require("rxjs/operators"), require("tslib"), require("uuid"));else if (typeof define === "function" && define.amd) define(["@mq/aurora-logging", "@mq/aurora-redux-middleware", "ldclient-js", "lodash-es/intersectionWith", "lodash-es/isEmpty", "lodash-es/isEqual", "lodash-es/isString", "lodash-es/memoize", "lodash-es/sortBy", "lodash-es/uniqueId", "react", "rxjs", "rxjs/operators", "tslib", "uuid"], r);else if (typeof exports === "object") exports["@mq/aurora-launcher-core"] = r(require("@mq/aurora-logging"), require("@mq/aurora-redux-middleware"), require("ldclient-js"), require("lodash-es/intersectionWith"), require("lodash-es/isEmpty"), require("lodash-es/isEqual"), require("lodash-es/isString"), require("lodash-es/memoize"), require("lodash-es/sortBy"), require("lodash-es/uniqueId"), require("react"), require("rxjs"), require("rxjs/operators"), require("tslib"), require("uuid"));else e["@mq/aurora-launcher-core"] = r(e["@mq/aurora-logging"], e["@mq/aurora-redux-middleware"], e["ldclient-js"], e["lodash-es/intersectionWith"], e["lodash-es/isEmpty"], e["lodash-es/isEqual"], e["lodash-es/isString"], e["lodash-es/memoize"], e["lodash-es/sortBy"], e["lodash-es/uniqueId"], e["react"], e["rxjs"], e["rxjs/operators"], e["tslib"], e["uuid"]);
})(typeof self !== "undefined" ? self : this, function (e, r, t, n, i, s, o, a, u, c, l, d, f, v, p) {
  return function () {
    "use strict";

    var h = {
      5: function (r) {
        r.exports = e;
      },
      831: function (e) {
        e.exports = r;
      },
      998: function (e) {
        e.exports = t;
      },
      96: function (e) {
        e.exports = n;
      },
      829: function (e) {
        e.exports = i;
      },
      153: function (e) {
        e.exports = s;
      },
      575: function (e) {
        e.exports = o;
      },
      211: function (e) {
        e.exports = a;
      },
      381: function (e) {
        e.exports = u;
      },
      777: function (e) {
        e.exports = c;
      },
      297: function (e) {
        e.exports = l;
      },
      435: function (e) {
        e.exports = d;
      },
      214: function (e) {
        e.exports = f;
      },
      780: function (e) {
        e.exports = v;
      },
      231: function (e) {
        e.exports = p;
      }
    };
    var _ = {};
    function __webpack_require__(e) {
      var r = _[e];
      if (r !== undefined) {
        return r.exports;
      }
      var t = _[e] = {
        exports: {}
      };
      h[e](t, t.exports, __webpack_require__);
      return t.exports;
    }
    !function () {
      __webpack_require__.n = function (e) {
        var r = e && e.__esModule ? function () {
          return e["default"];
        } : function () {
          return e;
        };
        __webpack_require__.d(r, {
          a: r
        });
        return r;
      };
    }();
    !function () {
      __webpack_require__.d = function (e, r) {
        for (var t in r) {
          if (__webpack_require__.o(r, t) && !__webpack_require__.o(e, t)) {
            Object.defineProperty(e, t, {
              enumerable: true,
              get: r[t]
            });
          }
        }
      };
    }();
    !function () {
      __webpack_require__.o = function (e, r) {
        return Object.prototype.hasOwnProperty.call(e, r);
      };
    }();
    !function () {
      __webpack_require__.r = function (e) {
        if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
          Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
          });
        }
        Object.defineProperty(e, "__esModule", {
          value: true
        });
      };
    }();
    var g = {};
    !function () {
      __webpack_require__.r(g);
      __webpack_require__.d(g, {
        ACTION_PREFIX: function () {
          return r;
        },
        CLOSE_RE_AUTHENTICATE_MODAL: function () {
          return I;
        },
        DEFAULT_LD_CONTEXT: function () {
          return O;
        },
        DEVELOPER_SITE_PREFIX: function () {
          return t;
        },
        Env: function () {
          return d;
        },
        GATrack: function () {
          return m;
        },
        GET_REALM: function () {
          return l;
        },
        LAUNCH_DARKLY_CHANNEL: function () {
          return W;
        },
        LOGOUT: function () {
          return S;
        },
        LaunchDarklyContext: function () {
          return U;
        },
        LaunchDarklyProvider: function () {
          return B;
        },
        LaunchDarklyRealmIDs: function () {
          return G;
        },
        LaunchDarklyService: function () {
          return Y;
        },
        LaunchDarklyServiceProxy: function () {
          return Z;
        },
        MARQUEE_AURORA_CDN_PREFIX: function () {
          return n;
        },
        MARQUEE_DESKTOP_CDN_PREFIX: function () {
          return i;
        },
        MARQUEE_DESKTOP_PREFIX: function () {
          return s;
        },
        MARQUEE_SITE_PREFIX: function () {
          return o;
        },
        OPEN_RE_AUTHENTICATE_MODAL: function () {
          return L;
        },
        ResourceService: function () {
          return ce;
        },
        SessionService: function () {
          return ge;
        },
        USER_AUTH_LEVEL: function () {
          return E;
        },
        USER_ENTITLEMENT: function () {
          return R;
        },
        USER_ENTITLEMENT_V2: function () {
          return T;
        },
        authentication: function () {
          return authentication;
        },
        checkIsFeatureEnabledInLaunchDarkly: function () {
          return checkIsFeatureEnabledInLaunchDarkly;
        },
        closeReAuthenticateModal: function () {
          return closeReAuthenticateModal;
        },
        convertV2UserToV1: function () {
          return convertV2UserToV1;
        },
        disposeGA: function () {
          return disposeGA;
        },
        entitlement: function () {
          return entitlement;
        },
        entitlementV2: function () {
          return entitlementV2;
        },
        getRealm: function () {
          return getRealm;
        },
        getUserAuthenticationStatus: function () {
          return getUserAuthenticationStatus;
        },
        getUserEntitlement: function () {
          return getUserEntitlement;
        },
        getUserEntitlementV2: function () {
          return getUserEntitlementV2;
        },
        initialAuthenticationState: function () {
          return y;
        },
        initialEntitlementState: function () {
          return A;
        },
        initialEntitlementStateV2: function () {
          return k;
        },
        initialRealmState: function () {
          return P;
        },
        initializeGA: function () {
          return initializeGA;
        },
        launchDarkly: function () {
          return z;
        },
        logout: function () {
          return logout;
        },
        openReAuthenticateModal: function () {
          return openReAuthenticateModal;
        },
        reAuthenticate: function () {
          return reAuthenticate;
        },
        realm: function () {
          return realm;
        },
        useResources: function () {
          return useResources;
        },
        useResourcesPriv: function () {
          return useResourcesPriv;
        },
        useSessionCapture: function () {
          return useSessionCapture;
        },
        withLaunchDarklyContext: function () {
          return withLaunchDarklyContext;
        }
      });
      var e = __webpack_require__(831);
      var r = "LAUNCHER";
      var t = "/discover";
      var n = "/resources";
      var i = "/desktop-resources";
      var s = "/desktop";
      var o = "/s";
      var createRequestHeaders = function (e) {
        return {
          "X-Dash-AppId": e,
          "Content-Type": "application/json;charset=utf-8"
        };
      };
      var a = __webpack_require__(780);
      var u = __webpack_require__(211);
      var c = __webpack_require__.n(u);
      var l = r + "_GET_REALM";
      var d;
      (function (e) {
        e["alpha"] = "alpha";
        e["dev"] = "dev";
        e["qa"] = "qa";
        e["prod"] = "prod";
        e["preview"] = "preview";
      })(d || (d = {}));
      var f = c()(function (r) {
        return e.request.getText("/realm", undefined, {
          headers: createRequestHeaders(r)
        });
      });
      var getRealm = function (e) {
        return {
          baseType: l,
          callAPI: function () {
            return f(e);
          }
        };
      };
      function gaAnalyticsIsogram(e, r, t, n, i, s, o) {
        e["GoogleAnalyticsObject"] = i;
        e[i] = e[i] || function () {
          (e[i].q = e[i].q || []).push(arguments);
        }, e[i].l = 1 * new Date().getTime();
        s = r.createElement(t), o = r.getElementsByTagName(t)[0];
        s.async = 1;
        s.src = n;
        o.parentNode.insertBefore(s, o);
      }
      var v = {
        HIT_TIME: "dimension5",
        INTERNAL_OR_NO: "dimension4",
        STS_USER_OR_NO: "dimension6",
        USER_ID: "dimension2"
      };
      var setPageLocation = function (e) {
        var r = window.ga;
        var t = window.isProd;
        var n = getGaCommandForPathAndRealm("set", e, t);
        var i = cleanPath(e);
        if (r) {
          r(n, {
            location: getHostName() + i
          });
        }
      };
      var getLocationHostName = function () {
        return window.location.hostname;
      };
      var getLocationPathName = function () {
        return window.location.pathname;
      };
      var getLocationUri = function () {
        return window.location.href.replace(window.location.origin, "");
      };
      var p = {
        QA: "UA-96382331-16"
      };
      var h = {
        ANALYTICS: {
          PATTERN: new RegExp("^(/s)?/(portfolios|hedging)(.*)$"),
          PROD: "UA-96382331-45",
          QA: p.QA
        },
        CONTENT: {
          PATTERN: new RegExp("(^(/s)?/content-feature/(.*)$)|(^/desktop/features/content(.*)$)"),
          PROD: "UA-96382331-3",
          QA: "UA-96382331-12"
        },
        DATA_SERVICES: {
          PATTERN: new RegExp("^(/s)?/(plottool)(.*)$"),
          PROD: "UA-96382331-46",
          QA: p.QA
        },
        DEVELOPER: {
          PATTERN: new RegExp("(^/s/developer(.*)$)"),
          PROD: "UA-96382331-10",
          QA: p.QA
        },
        DEVELOPER_SITE: {
          PATTERN: new RegExp("(^/discover(.*)$)|(^/thoughts(.*)$)|(^/docs(.*)$)|(^/platforms(.*)$)|(^/p/(.*)$)|(^/go/(.*)$)|(^/console/(.*)$)|(^/blog/(.*)$)"),
          PROD: "UA-96382331-44",
          QA: p.QA
        },
        EARON: {
          PATTERN: new RegExp("^(.*)?/earon(.*)$"),
          PROD: "UA-96382331-19",
          QA: p.QA
        },
        HOMEPAGE: {
          PATTERN: new RegExp("^/s/home(.*)$"),
          PROD: "UA-96382331-15",
          QA: p.QA
        },
        MARKETING_SITE_PUBLIC: {
          PATTERN: new RegExp("^/welcome(.*)$"),
          PROD: "UA-96382331-48",
          QA: p.QA
        },
        POLLS: {
          PATTERN: new RegExp("^(/s)?/(surveys|polls)(.*)$"),
          PROD: "UA-96382331-11",
          QA: "UA-96382331-13"
        },
        PROFILE: {
          PATTERN: new RegExp("^(/s)?/profile(.*)$"),
          PROD: "UA-96382331-35"
        },
        RESEARCH: {
          PATTERN: new RegExp("^(/s/research|/content/(research|site))(.*)$"),
          PROD: "UA-96382331-3",
          QA: "UA-96382331-12"
        },
        STUDIO: {
          PATTERN: new RegExp("^/studio(.*)$"),
          PROD: "UA-96382331-1",
          QA: "UA-96382331-7"
        },
        TRADEBUILDER: {
          PATTERN: new RegExp("^(/s)?/trade-builder(.*)$"),
          PROD: "UA-96382331-39"
        },
        TRADING: {
          PATTERN: new RegExp("^(/s)?/trader(.*)$"),
          PROD: "UA-96382331-19",
          QA: p.QA
        }
      };
      var _ = ["PROD", "QA"];
      var getHostName = function () {
        var e = getLocationHostName();
        if (e.search(".firmwide.corp.gs.com") > -1 || e.search(".desktop.services.gs.com") > -1 || e.search(".url.gs.com") > -1) {
          return "desktop.services.gs.com";
        }
        return e;
      };
      var loadGA = function (e) {
        gaAnalyticsIsogram(window, document, "script", e && e.debug ? "https://www.google-analytics.com/analytics_debug.js" : "https://www.google-analytics.com/analytics.js", "ga");
      };
      var cleanPath = function (e) {
        return e[e.length - 1] === "/" ? e.slice(0, -1) : e;
      };
      var trackerFn = function () {
        var e = getLocationPathName();
        var r = window.isProd;
        var t = getTrackerNameForPath(e, r);
        var n = window.ga;
        var i = n.getByName(t);
        var s = i.get("buildHitTask");
        if (i) {
          i.set("buildHitTask", function (e) {
            var r = i.get("userId");
            e.set(v.HIT_TIME, String(new Date().toString()), true);
            e.set(v.USER_ID, r, true);
            s(e);
          });
        }
      };
      var sendGoogleAnalyticsEvent = function (e) {
        var r = window.ga;
        var t = e.target;
        if (t) {
          t.removeAttribute("data-event-start-ts");
          if (typeof r !== "undefined") {
            var n = t.getAttribute("data-event-action");
            if (e.type === "mouseout") {
              n = "Hovered";
            }
            var i = t.getAttribute("data-event-category");
            var s = t.getAttribute("data-event-label");
            if (i && n) {
              var o = {
                eventCategory: i,
                eventAction: n,
                eventLabel: s
              };
              ga_analytics_event(o);
            }
          }
        }
      };
      var getGoogleAnalyticsInfoForPath = function (e, r) {
        for (var t in h) {
          if (h.hasOwnProperty(t)) {
            var n = h[t];
            var i = n.PATTERN;
            if (i.test(e)) {
              if (r === true && "PROD" in n) {
                return {
                  name: t,
                  realm: "PROD",
                  trackId: n.PROD
                };
              } else if (r === false && "QA" in n) {
                return {
                  name: t,
                  realm: "QA",
                  trackId: n.QA
                };
              }
            }
          }
        }
        return r ? {
          name: "HOMEPAGE",
          realm: "PROD",
          trackId: h.HOMEPAGE.PROD
        } : {
          name: "HOMEPAGE",
          realm: "QA",
          trackId: h.HOMEPAGE.QA
        };
      };
      var getTrackerNameForProperty = function (e, r) {
        return e + "__" + r;
      };
      var getTrackerNameForPropertyInfo = function (e) {
        return e.name + "__" + e.realm;
      };
      var getTrackerNameForPath = function (e, r) {
        var t = getGoogleAnalyticsInfoForPath(e, r);
        return getTrackerNameForPropertyInfo(t);
      };
      var getGaCommandForPathAndRealm = function (e, r, t) {
        var n = getTrackerNameForPath(r, t);
        return n + "." + e;
      };
      var initializeGA = function (e, r, t) {
        var n;
        if (t === void 0) {
          t = false;
        }
        var i = r === d.prod;
        window.isProd = i;
        loadGA({
          debug: t
        });
        var s = window.ga;
        if (s) {
          var o = e.analyticsId || "no-id-set";
          for (var a in h) {
            if (h.hasOwnProperty(a)) {
              var u = h[a];
              for (var c = 0, l = _; c < l.length; c++) {
                var f = l[c];
                if (f in u) {
                  var p = u[f];
                  var g = getTrackerNameForProperty(a, f);
                  var b = g + ".set";
                  s("create", p, {
                    name: g,
                    cookieDomain: "auto",
                    userId: o
                  });
                  s(b, (n = {
                    transport: t ? "image" : "beacon",
                    anonymizeIp: true,
                    forceSSL: true,
                    hostname: getHostName(),
                    userId: o
                  }, n[v.USER_ID] = o, n[v.INTERNAL_OR_NO] = e.internal, n));
                }
              }
            }
          }
          s(trackerFn);
          pageview(getLocationPathName(), getLocationUri());
          document.addEventListener("mousedown", sendGoogleAnalyticsEvent);
          document.addEventListener("mouseover", handleMouseOver);
          document.addEventListener("mouseout", handleMouseOut);
        }
      };
      var disposeGA = function () {
        document.removeEventListener("mousedown", sendGoogleAnalyticsEvent);
        document.removeEventListener("mouseover", handleMouseOver);
        document.removeEventListener("mouseout", handleMouseOut);
      };
      var handleMouseOver = function (e) {
        var r = e.timeStamp;
        var t = e.target;
        if (t) {
          var n = t.getAttribute("data-event-category");
          var i = t.getAttribute("data-event-start-ts");
          if (n && !i) {
            t.setAttribute("data-event-start-ts", r.toString());
          }
        }
      };
      var b = 1e3;
      var handleMouseOut = function (e) {
        var r = e.timeStamp;
        var t = e.target;
        if (t) {
          var n = t.getAttribute("data-event-category");
          var i = t.getAttribute("data-event-start-ts");
          if (n && i && i !== "") {
            if (r - window.parseInt(i, 10) >= b) {
              sendGoogleAnalyticsEvent(e);
            }
            t.removeAttribute("data-event-start-ts");
          }
        }
      };
      var pageview = function (e, r) {
        var t = window.ga;
        var n = window.isProd;
        if (t) {
          var i = getGaCommandForPathAndRealm("send", e, n);
          if (r) {
            setPageLocation(r);
          }
          t(i, "pageview", cleanPath(e));
        }
      };
      var currentPageview = function () {
        pageview(getLocationPathName(), getLocationUri());
      };
      var ga_analytics_event = function (e) {
        setPageLocation(getLocationUri());
        var r = window.ga;
        var t = window.isProd;
        var n = getLocationPathName();
        var i = {};
        if (e.customDimensions) {
          for (var s = 0, o = e.customDimensions; s < o.length; s++) {
            var u = o[s];
            i[u.cdName] = u.cdValue;
          }
          delete e.customDimensions;
        }
        if (r) {
          var c = getGaCommandForPathAndRealm("send", n, t);
          r(c, (0, a.__assign)((0, a.__assign)((0, a.__assign)({}, i), e), {
            hitType: "event"
          }));
        }
      };
      var m = {
        pageview: pageview,
        currentPageview: currentPageview,
        event: ga_analytics_event
      };
      var E = r + "_USER_AUTH_LEVEL";
      var getUserAuthenticationStatus = function (r) {
        return {
          baseType: E,
          callAPI: function () {
            return e.request.get("/v1/authentication/status", undefined, {
              headers: createRequestHeaders(r)
            });
          }
        };
      };
      var y = {
        isFetching: true
      };
      var authentication = function (e, r) {
        if (e === void 0) {
          e = y;
        }
        switch (r.type) {
          case "REQ_" + E:
            return (0, a.__assign)((0, a.__assign)({}, e), {
              isFetching: true,
              authLevel: undefined,
              authLevelName: undefined,
              expiresIn: undefined,
              issueTime: undefined,
              xhrError: undefined
            });
          case "RECV_" + E:
            return (0, a.__assign)((0, a.__assign)((0, a.__assign)({}, e), r.response), {
              isFetching: false
            });
          case "XHR_ERROR_" + E:
            return (0, a.__assign)((0, a.__assign)({}, e), {
              isFetching: false,
              xhrError: r.error
            });
        }
        return e;
      };
      var R = r + "_USER_ENTITLEMENT";
      var S = r + "_LOGOUT";
      var w = c()(function (r) {
        return e.request.get("/v1/users/self", undefined, {
          headers: createRequestHeaders(r)
        });
      });
      var getUserEntitlement = function (e) {
        return {
          baseType: R,
          callAPI: function () {
            return w(e);
          }
        };
      };
      var logout = function (r) {
        return {
          baseType: S,
          callAPI: function () {
            return e.request.get("/logout", undefined, {
              headers: createRequestHeaders(r),
              credentials: "include"
            }).then(function () {
              return window.location.reload();
            });
          }
        };
      };
      var A = {
        isFetching: true
      };
      var entitlement = function (e, r) {
        if (e === void 0) {
          e = A;
        }
        switch (r.type) {
          case "REQ_" + R:
            return (0, a.__assign)((0, a.__assign)({}, e), {
              isFetching: true,
              xhrError: undefined
            });
          case "RECV_" + R:
            {
              var t = r.response;
              t.tokens = t.tokens || [];
              var n = t.tokens.filter(function (e) {
                return e.startsWith("group:");
              }).map(function (e) {
                return e.replace("group:", "");
              });
              var i = t.tokens.filter(function (e) {
                return e.startsWith("role:");
              }).map(function (e) {
                return e.replace("role:", "");
              });
              return Object.assign({}, e, {
                profile: t,
                entitlement: {
                  groups: n,
                  roles: i,
                  tokens: t.tokens
                },
                isFetching: false
              });
            }
          case "XHR_ERROR_" + R:
            return (0, a.__assign)((0, a.__assign)({}, e), {
              isFetching: false,
              xhrError: r.error
            });
          default:
            return e;
        }
      };
      var T = r + "_USER_ENTITLEMENT_V2";
      var D = c()(function (r) {
        return e.request.get("/v2/users/self", undefined, {
          headers: createRequestHeaders(r)
        });
      });
      var getUserEntitlementV2 = function (e) {
        return {
          baseType: T,
          callAPI: function () {
            return D(e);
          }
        };
      };
      var k = {
        isFetching: true
      };
      var convertV2UserToV1 = function (e) {
        var r = e.marqueeTokens && e.marqueeTokens.filter(function (e) {
          return e.startsWith("group:");
        }).map(function (e) {
          return e.replace("group:", "");
        });
        var t = e.entitlementRoles && e.entitlementRoles.filter(function (e) {
          return e && e.indexOf(":") > 0;
        }).map(function (e) {
          return e.split(":")[1];
        });
        return {
          active: e.active,
          analyticsId: e.analyticsId,
          appUser: e.apiUser,
          city: e.addressCity,
          company: e.oeName,
          country: e.addressCountry,
          coverage: e.coverage && e.coverage.marquee,
          email: e.email,
          firstName: e.firstName,
          groups: r,
          id: e.id,
          internal: e.employee,
          internalEmail: e.internalEmail,
          internalID: e.internalId,
          kerberos: e.kerberos,
          lastName: e.lastName,
          login: e.login,
          marqueeExperience: e.marqueeExperience,
          miFIDIITradeIdeaDeclined: e.miFIDIITradeIdeaDeclined,
          name: e.lastName && e.firstName ? e.lastName + ", " + e.firstName : "",
          region: e.addressRegion,
          roles: t,
          tokens: e.marqueeTokens
        };
      };
      var entitlementV2 = function (e, r) {
        if (e === void 0) {
          e = k;
        }
        switch (r.type) {
          case "REQ_" + T:
            return (0, a.__assign)((0, a.__assign)({}, e), {
              isFetching: true,
              xhrError: undefined
            });
          case "RECV_" + T:
            {
              var t = r.response;
              var n = convertV2UserToV1(t);
              return Object.assign({}, e, {
                profile: n,
                entitlement: {
                  groups: n.groups,
                  roles: n.roles,
                  tokens: n.tokens
                },
                isFetching: false
              });
            }
          case "XHR_ERROR_" + T:
            return (0, a.__assign)((0, a.__assign)({}, e), {
              isFetching: false,
              xhrError: r.error
            });
          default:
            return e;
        }
      };
      var I = r + "_CLOSE_RE_AUTHENTICATE_MODAL";
      var L = r + "_OPEN_RE_AUTHENTICATE_MODAL";
      var closeReAuthenticateModal = function () {
        return {
          type: I
        };
      };
      var openReAuthenticateModal = function () {
        return {
          type: L
        };
      };
      var q = {
        isModalShowing: false
      };
      var reAuthenticate = function (e, r) {
        if (e === void 0) {
          e = q;
        }
        switch (r.type) {
          case I:
            return (0, a.__assign)((0, a.__assign)({}, e), {
              isModalShowing: false
            });
          case L:
            return (0, a.__assign)((0, a.__assign)({}, e), {
              isModalShowing: true
            });
          default:
            return e;
        }
      };
      var P = {
        isFetching: true
      };
      var realm = function (e, r) {
        if (e === void 0) {
          e = P;
        }
        switch (r.type) {
          case "REQ_" + l:
            return (0, a.__assign)((0, a.__assign)({}, e), {
              isFetching: true,
              xhrError: undefined
            });
          case "RECV_" + l:
            return (0, a.__assign)((0, a.__assign)({}, e), {
              isFetching: false,
              env: r.response
            });
          case "XHR_ERROR_" + l:
            return (0, a.__assign)((0, a.__assign)({}, e), {
              isFetching: false,
              xhrError: r.error
            });
          default:
            return e;
        }
      };
      var x = __webpack_require__(297);
      var O = {
        flags: {},
        connected: false
      };
      var U = x.createContext(O);
      var N = __webpack_require__(777);
      var C = __webpack_require__.n(N);
      var Q = __webpack_require__(153);
      var F = __webpack_require__.n(Q);
      var j = __webpack_require__(435);
      var M = __webpack_require__(214);
      var V = __webpack_require__(5);
      var H = V.loggerFactory.getLogger("LaunchDarkly");
      var $ = function () {
        function LaunchDarkly() {
          var e = this;
          this.id = C()();
          this._flags = new j.BehaviorSubject(O);
          this._connected = new j.BehaviorSubject(false);
          this.getFlags = function () {
            return e._flags.getValue();
          };
          this.getConnected = function () {
            return e._connected.getValue();
          };
        }
        Object.defineProperty(LaunchDarkly.prototype, "flags", {
          get: function () {
            return this._flags.asObservable().pipe((0, M.distinctUntilChanged)(function (e, r) {
              return F()(e, r);
            }));
          },
          enumerable: false,
          configurable: true
        });
        Object.defineProperty(LaunchDarkly.prototype, "connected", {
          get: function () {
            return this._connected.asObservable().pipe((0, M.distinctUntilChanged)());
          },
          enumerable: false,
          configurable: true
        });
        LaunchDarkly.prototype.initialize = function (e) {
          H.info("[LaunchDarkly:" + this.id + "] linking to service: " + e.toString());
          var r = this;
          this.flagsSubscription = e.flags.subscribe({
            next: function (e) {
              return r._flags.next(e);
            }
          });
          this.connectedSubscription = e.connected.subscribe({
            next: function (e) {
              return r._connected.next(e);
            }
          });
        };
        LaunchDarkly.prototype.close = function () {
          if (this.flagsSubscription) {
            this.flagsSubscription.unsubscribe();
          }
          if (this.connectedSubscription) {
            this.connectedSubscription.unsubscribe();
          }
        };
        LaunchDarkly.prototype.toString = function () {
          return "[LaunchDarkly:" + this.id + "]";
        };
        return LaunchDarkly;
      }();
      var z = new $();
      var B = function (e) {
        (0, a.__extends)(LaunchDarklyProvider, e);
        function LaunchDarklyProvider(r) {
          var t = e.call(this, r) || this;
          t.ldSubscription = undefined;
          t.state = {
            flags: O.flags,
            connected: O.connected
          };
          return t;
        }
        LaunchDarklyProvider.prototype.componentDidMount = function () {
          var e = this;
          this.ldSubscription = z.flags.subscribe({
            next: function (r) {
              e.setState({
                flags: r.flags,
                connected: r.connected
              });
            }
          });
        };
        LaunchDarklyProvider.prototype.componentWillUnmount = function () {
          if (this.ldSubscription) {
            this.ldSubscription.unsubscribe();
          }
        };
        LaunchDarklyProvider.prototype.render = function () {
          return x.createElement(U.Provider, {
            value: this.state
          }, this.props.children);
        };
        return LaunchDarklyProvider;
      }(x.Component);
      var G = {
        QA: "5c5b57b623fa0d33c816585b",
        DEV: "5c3d1e41082f9834fcf5b4c0",
        PROD: "5be0a49b23e69015f8cdf624"
      };
      var X = __webpack_require__(998);
      var W = "launch-darkly-channel";
      var K = V.loggerFactory.getLogger("LaunchDarklyService");
      var Y = function () {
        function LaunchDarklyService(e) {
          var r = this;
          if (e === void 0) {
            e = false;
          }
          this.withBroadCastChannel = e;
          this.id = C()();
          this._flags = new j.BehaviorSubject(O);
          this._connected = new j.BehaviorSubject(false);
          this.initializedRealm = undefined;
          this.initializedUser = undefined;
          this.updateFlags = function () {
            K.info("[LaunchDarklyService:" + r.id + "] Flags updated");
            r._flags.next({
              flags: r.ldclient.allFlags(),
              connected: r._connected.getValue()
            });
          };
          this.getLDRealm = function (e) {
            if (e === d.dev || e === d.alpha || e === d.preview) {
              return G.DEV;
            } else if (e === d.qa) {
              return G.QA;
            } else if (e === d.prod) {
              return G.PROD;
            }
            return undefined;
          };
          this.getLDUser = function (e) {
            var r, t;
            if (e && e.id) {
              return {
                key: e.id,
                custom: {
                  countryMq: e.country,
                  groups: e.groups,
                  isInternal: (t = (r = e.tokens) === null || r === void 0 ? void 0 : r.includes("internal")) !== null && t !== void 0 ? t : false,
                  region: e.region,
                  roles: e.roles
                }
              };
            }
            return undefined;
          };
          K.info("[LaunchDarklyService:" + this.id + "] creating with broadcast channel: " + e);
          if (e) {
            var t = new BroadcastChannel(W);
            this._flags.subscribe({
              next: function (e) {
                t.postMessage(e);
              }
            });
            this._connected.subscribe({
              next: function (e) {
                t.postMessage({
                  connected: e
                });
              }
            });
            t.onmessage = function (e) {
              if (e.data) {
                if (e.data.pushUpdate) {
                  t.postMessage({
                    connected: r._connected.getValue()
                  });
                  t.postMessage(r._flags.getValue());
                }
              }
            };
          }
        }
        LaunchDarklyService.prototype.configure = function (e, r) {
          if (e !== this.initializedRealm || r !== this.initializedUser) {
            this.configureLD(e, r);
          }
        };
        Object.defineProperty(LaunchDarklyService.prototype, "flags", {
          get: function () {
            return this._flags.asObservable().pipe((0, M.distinctUntilChanged)(function (e, r) {
              return F()(e, r);
            }));
          },
          enumerable: false,
          configurable: true
        });
        LaunchDarklyService.prototype.getFlags = function () {
          return this._flags.getValue();
        };
        Object.defineProperty(LaunchDarklyService.prototype, "connected", {
          get: function () {
            return this._connected.asObservable().pipe((0, M.distinctUntilChanged)());
          },
          enumerable: false,
          configurable: true
        });
        LaunchDarklyService.prototype.getConnected = function () {
          return this._connected.getValue();
        };
        LaunchDarklyService.prototype.configureLD = function (e, r) {
          var t = this;
          this._connected.next(false);
          var n = this.getLDRealm(e);
          var i = this.getLDUser(r);
          if (n !== undefined && i !== undefined) {
            K.info("[LaunchDarklyService:" + this.id + "] Initializing Launch darkly. realm: " + n + ", user: " + i.key + ", withBroadCastChannel: " + this.withBroadCastChannel);
            this.ldclient = X.initialize(n, i, {
              streaming: true,
              useReport: true,
              allAttributesPrivate: true
            });
            var s = this;
            this.ldclient.waitForInitialization().then(function () {
              K.info("[LaunchDarklyService:" + s.id + "] Launch darkly initialized");
              s._connected.next(true);
              s.ldclient.on("change", s.updateFlags);
              s.initializedRealm = e;
              s.initializedUser = r;
              s.updateFlags();
            }).catch(function (e) {
              s._connected.next(false);
              t._flags.next(O);
              K.error("[LaunchDarklyService:" + s.id + "] Launch darkly failed to initialized. Default values will be used", {
                error: e
              });
            });
          } else {
            if (this._connected.getValue()) {
              K.error("[LaunchDarklyService:" + this.id + "]. User or Real is unknown. User: " + i + ", Realm: " + n + ". Default values will be used");
            }
            this._flags.next(O);
          }
        };
        LaunchDarklyService.prototype.close = function () {
          this.ldclient.off("change", this.updateFlags);
          this._connected.next(false);
          this.initializedRealm = undefined;
          this.initializedUser = undefined;
          if (this.bc) {
            this.bc.close();
          }
        };
        LaunchDarklyService.prototype.toString = function () {
          return "[LaunchDarklyService:" + this.id + "]";
        };
        return LaunchDarklyService;
      }();
      var J = V.loggerFactory.getLogger("LaunchDarklyServiceProxy");
      var Z = function () {
        function LaunchDarklyServiceProxy() {
          this.id = C()();
          this._flags = new j.BehaviorSubject(O);
          this._connected = new j.BehaviorSubject(false);
          var e = this;
          var r = new BroadcastChannel(W);
          this.flags.subscribe({
            next: function () {
              J.info("[LaunchDarklyServiceProxy:" + e.id + "] flags updated");
            }
          });
          this.connected.subscribe({
            next: function (r) {
              J.info("[LaunchDarklyServiceProxy:" + e.id + "] connected: " + r);
            }
          });
          r.onmessage = function (r) {
            if (r.data) {
              if (r.data.flags) {
                e._flags.next({
                  flags: r.data.flags,
                  connected: r.data.connected
                });
              } else if (r.data.connected !== undefined) {
                e._connected.next(r.data.connected);
              }
            }
          };
          r.postMessage({
            pushUpdate: true
          });
          self.addEventListener("beforeunload", function () {
            r.close();
          });
        }
        Object.defineProperty(LaunchDarklyServiceProxy.prototype, "flags", {
          get: function () {
            return this._flags.asObservable().pipe((0, M.distinctUntilChanged)(function (e, r) {
              return F()(e, r);
            }));
          },
          enumerable: false,
          configurable: true
        });
        LaunchDarklyServiceProxy.prototype.getFlags = function () {
          return this._flags.getValue();
        };
        Object.defineProperty(LaunchDarklyServiceProxy.prototype, "connected", {
          get: function () {
            return this._connected.asObservable().pipe((0, M.distinctUntilChanged)());
          },
          enumerable: false,
          configurable: true
        });
        LaunchDarklyServiceProxy.prototype.getConnected = function () {
          return this._connected.getValue();
        };
        LaunchDarklyServiceProxy.prototype.toString = function () {
          return "[LaunchDarklyServiceProxy:" + this.id + "]";
        };
        return LaunchDarklyServiceProxy;
      }();
      function withLaunchDarklyContext(e) {
        return function (r) {
          return x.createElement(U.Consumer, null, function (t) {
            return x.createElement(e, (0, a.__assign)({}, r, t));
          });
        };
      }
      var ee = __webpack_require__(575);
      var re = __webpack_require__.n(ee);
      var checkIsFeatureEnabledInLaunchDarkly = function (e) {
        var r = e.launchDarklyFlags,
          t = e.flags;
        var n = !(r === undefined || Array.isArray(r) && r.length === 0);
        if (!n) {
          return true;
        }
        var i = !!Object.keys(t).length;
        if (typeof r === "function") {
          try {
            return !!r({
              flags: t
            });
          } catch (e) {
            return false;
          }
        }
        return r.some(function (e) {
          if (re()(e)) {
            return t[e] === true;
          }
          var r = e,
            n = r.flag,
            s = r.fallback;
          if (!i || t[n] === undefined) {
            return s !== null && s !== void 0 ? s : false;
          }
          return t[n] === true;
        });
      };
      var te = __webpack_require__(96);
      var ne = __webpack_require__.n(te);
      var ie = __webpack_require__(829);
      var se = __webpack_require__.n(ie);
      var oe = __webpack_require__(381);
      var ae = __webpack_require__.n(oe);
      var resource_service_createRequestHeaders = function (e) {
        return {
          "X-Dash-AppId": e,
          "Content-Type": "application/json;charset=utf-8"
        };
      };
      var ue = V.loggerFactory.getLogger("ResourceService");
      var ce = function () {
        function ResourceService() {
          this.resourcesUpdate$ = new j.BehaviorSubject({});
          this.isResourceLoading = false;
          this.intervalId = null;
        }
        Object.defineProperty(ResourceService.prototype, "isLoading", {
          get: function () {
            return this.isResourceLoading;
          },
          enumerable: false,
          configurable: true
        });
        ResourceService.prototype.isPollingStarted = function () {
          return this.intervalId !== null;
        };
        ResourceService.prototype.initializeService = function (e, r) {
          var t = this;
          if (r === void 0) {
            r = 3e5;
          }
          if (!this.isPollingStarted()) {
            this.fetchResources(e);
            this.intervalId = setInterval(function () {
              return t.fetchResources(e);
            }, r);
          }
        };
        ResourceService.prototype.fetchResources = function (r) {
          return (0, a.__awaiter)(this, void 0, void 0, function () {
            var t, n, i, s, o, i;
            return (0, a.__generator)(this, function (u) {
              switch (u.label) {
                case 0:
                  t = Date.now();
                  u.label = 1;
                case 1:
                  u.trys.push([1, 3,, 4]);
                  ue.info("Fetching the resources...");
                  this.isResourceLoading = true;
                  return [4, e.request.get("/v1/authorization/resources/self", undefined, {
                    headers: resource_service_createRequestHeaders(r)
                  })];
                case 2:
                  n = u.sent();
                  this.isResourceLoading = false;
                  ue.info("Successfully fetched resources in " + (Date.now() - t) + " millis");
                  i = {
                    lastUpdatedAt: Date.now(),
                    xhrError: undefined,
                    resourcesResponse: n
                  };
                  this.resourcesUpdate$.next(i);
                  return [3, 4];
                case 3:
                  s = u.sent();
                  this.isResourceLoading = false;
                  o = "Failed to fetch resources: " + s.toString() + ", time took: " + (Date.now() - t) + " millis";
                  ue.error(o);
                  i = (0, a.__assign)((0, a.__assign)({}, this.resourcesUpdate$.value), {
                    lastUpdatedAt: Date.now(),
                    xhrError: s
                  });
                  this.resourcesUpdate$.next(i);
                  return [3, 4];
                case 4:
                  return [2];
              }
            });
          });
        };
        ResourceService.prototype.areResourcesEqual = function (e, r) {
          var t = {
            x: e.xhrError,
            y: e.resourcesResponse && e.resourcesResponse.resources ? ae()(e.resourcesResponse.resources) : undefined
          };
          var n = {
            x: r.xhrError,
            y: r.resourcesResponse && r.resourcesResponse.resources ? ae()(r.resourcesResponse.resources) : undefined
          };
          return F()(t, n);
        };
        ResourceService.prototype.getResourcesUpdates = function () {
          return this.resourcesUpdate$.pipe((0, M.filter)(function (e) {
            return !se()(e);
          }), (0, M.distinctUntilChanged)(this.areResourcesEqual));
        };
        ResourceService.prototype.getEntitledResources = function (e) {
          return this.getResourcesUpdates().pipe((0, M.filter)(function (e) {
            return e.resourcesResponse !== undefined;
          }), (0, M.map)(function (r) {
            return ne()(e, r.resourcesResponse.resources, F());
          }));
        };
        ResourceService.prototype.clearPollingResources = function () {
          if (this.intervalId !== null) clearInterval(this.intervalId);
        };
        ResourceService.getInstance = function () {
          return window.__mq_resourceService ? window.__mq_resourceService : window.__mq_resourceService = new ResourceService();
        };
        return ResourceService;
      }();
      var le = V.loggerFactory.getLogger("resource-hooks");
      function useResources(e, r) {
        if (r === void 0) {
          r = true;
        }
        var t = ce.getInstance();
        var n = (0, x.useState)([]),
          i = n[0],
          s = n[1];
        (0, x.useEffect)(function () {
          t.initializeService("MQSITE");
          var n = r ? t.getEntitledResources(e).subscribe(function (e) {
            return s(e);
          }, function (e) {
            return le.error("useResources: ", e);
          }) : t.getEntitledResources(e).pipe((0, M.first)()).subscribe(function (e) {
            return s(e);
          }, function (e) {
            return le.error("useResources: ", e);
          });
          return function () {
            return n.unsubscribe();
          };
        }, [JSON.stringify(e), r]);
        return i;
      }
      function useResourcesPriv(e) {
        if (e === void 0) {
          e = true;
        }
        var r = ce.getInstance();
        var t = (0, x.useState)(undefined),
          n = t[0],
          i = t[1];
        (0, x.useEffect)(function () {
          r.initializeService("MQSITE");
          var t = e ? r.getResourcesUpdates().subscribe(function (e) {
            return i(e.resourcesResponse && e.resourcesResponse.resources || []);
          }, function (e) {
            return le.error("useResourcesPriv: ", e);
          }) : r.getResourcesUpdates().pipe((0, M.first)()).subscribe(function (e) {
            return i(e.resourcesResponse && e.resourcesResponse.resources || []);
          }, function (e) {
            return le.error("useResourcesPriv: ", e);
          });
          return function () {
            t.unsubscribe();
            r.clearPollingResources();
          };
        }, [e]);
        return n;
      }
      var de = __webpack_require__(231);
      var fe = "MQSITE";
      var session_service_createRequestHeaders = function (e) {
        return {
          "X-Dash-AppId": e,
          "Content-Type": "application/json;charset=utf-8"
        };
      };
      var ve = V.loggerFactory.getLogger("SessionService");
      var pe = 5e3;
      var he = 1e3;
      var _e = 3e5;
      var ge = function () {
        function SessionService(e, r) {
          var t = this;
          this.isHidden = false;
          this.eventSubscriptions = [];
          this.userActionsQueue = new Map();
          this.resource = e;
          this.resourceId = r;
          this.seqNo = 0;
          this.elapsedDuration = 0;
          this.sessionId = (0, de.v4)();
          this.eventSubscriptions.push(this.subscribeToEvent("click"));
          this.eventSubscriptions.push(this.subscribeToEvent("keyup"));
          this.eventSubscriptions.push(this.subscribeToEvent("scroll"));
          this.eventSubscriptions.push(this.subscribeToEvent("mouseover"));
          this.eventSubscriptions.push(this.subscribeToVisibilityChange());
          this.elapsedDurationIntervalId = setTimeout(function () {
            return t.updateElapsedDuration();
          }, he);
          this.postSessionIntervalId = setTimeout(function () {
            return t.postSessionCapture();
          }, pe);
          this.resetTimeoutId = setTimeout(function () {
            return t.resetSession();
          }, _e);
          window.addEventListener("beforeunload", function () {
            return t.dispose();
          });
        }
        SessionService.startTracking = function (e, r) {
          if (!e) {
            throw new Error("Resource type required");
          }
          if (!r) {
            throw new Error("Resource id required");
          }
          var t = window.__mq_sessionServices;
          if (t && t[e + r]) {
            return t[e + r];
          } else {
            if (!t) {
              window.__mq_sessionServices = {};
            }
            var n = new SessionService(e, r);
            window.__mq_sessionServices[e + r] = n;
            return n;
          }
        };
        SessionService.prototype.dispose = function () {
          this.eventSubscriptions.forEach(function (e) {
            return e.unsubscribe();
          });
          this.eventSubscriptions = [];
          clearTimeout(this.postSessionIntervalId);
          clearTimeout(this.elapsedDurationIntervalId);
          clearTimeout(this.resetTimeoutId);
        };
        SessionService.prototype.updateElapsedDuration = function () {
          var e = this;
          if (!this.isHidden) {
            this.elapsedDuration = this.elapsedDuration + 1;
          }
          this.elapsedDurationIntervalId = setTimeout(function () {
            return e.updateElapsedDuration();
          }, he);
        };
        SessionService.prototype.subscribeToEvent = function (e, r) {
          var t = this;
          if (r === void 0) {
            r = 1e3;
          }
          return (0, j.fromEvent)(document, e).pipe((0, M.debounceTime)(r)).subscribe(function () {
            ve.debug(e + " happened!");
            t.addToQueue(e);
          });
        };
        SessionService.prototype.subscribeToVisibilityChange = function () {
          var e = this;
          return (0, j.fromEvent)(document, "visibilitychange").subscribe(function () {
            if (document.visibilityState === "hidden") {
              e.addToQueue("hidden");
              e.isHidden = true;
            } else {
              e.addToQueue("visible");
              e.isHidden = false;
            }
          });
        };
        SessionService.prototype.addToQueue = function (e) {
          if (!this.userActionsQueue.has(e)) {
            this.userActionsQueue.set(e, {
              action: e
            });
          }
        };
        SessionService.prototype.resetSession = function () {
          var e = this;
          ve.info("[resetSession] Session reset");
          clearTimeout(this.postSessionIntervalId);
          clearTimeout(this.elapsedDurationIntervalId);
          clearTimeout(this.resetTimeoutId);
          this.elapsedDuration = 0;
          this.seqNo = 0;
          this.sessionId = (0, de.v4)();
          this.postSessionIntervalId = setTimeout(function () {
            return e.postSessionCapture();
          }, pe);
          this.elapsedDurationIntervalId = setTimeout(function () {
            return e.updateElapsedDuration();
          }, he);
          this.resetTimeoutId = setTimeout(function () {
            return e.resetSession();
          }, _e);
        };
        SessionService.prototype.postSessionCapture = function () {
          return (0, a.__awaiter)(this, void 0, void 0, function () {
            var r, t;
            var n = this;
            return (0, a.__generator)(this, function (i) {
              switch (i.label) {
                case 0:
                  ve.debug("[postSessionCapture] Post capture triggered");
                  if (!(this.userActionsQueue.size > 0)) return [3, 4];
                  clearTimeout(this.resetTimeoutId);
                  this.resetTimeoutId = setTimeout(function () {
                    return n.resetSession();
                  }, _e);
                  r = {
                    sessionId: this.sessionId,
                    resource: this.resource,
                    resourceId: this.resourceId,
                    elapsedDuration: this.elapsedDuration,
                    seqNo: ++this.seqNo,
                    userActions: Array.from(this.userActionsQueue.values())
                  };
                  i.label = 1;
                case 1:
                  i.trys.push([1, 3,, 4]);
                  ve.debug("[postSessionCapture] Posting captured session data.");
                  return [4, e.request.post("/v1/sessions", r, {
                    headers: session_service_createRequestHeaders(fe)
                  })];
                case 2:
                  i.sent();
                  ve.debug("[postSessionCapture] Emptying queue");
                  this.userActionsQueue.clear();
                  return [3, 4];
                case 3:
                  t = i.sent();
                  ve.error("Failed to post session event", t);
                  return [3, 4];
                case 4:
                  this.postSessionIntervalId = setTimeout(function () {
                    return n.postSessionCapture();
                  }, pe);
                  return [2];
              }
            });
          });
        };
        return SessionService;
      }();
      function useSessionCapture(e, r) {
        var t = V.loggerFactory.getLogger("SessionService");
        (0, x.useEffect)(function () {
          try {
            t.info("[useSessionCapture] Initializing the service.");
            ge.startTracking(e, r);
          } catch (e) {
            t.warn("Failed to start tracking " + e);
          }
        }, [e, r]);
      }
    }();
    return g;
  }();
});